<template>
  <v-container fluid class="promotion-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/promotion/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="promotions-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="headers"
              :items="promotions"

              :items-per-page="promotionPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Promotion?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepromotion.promotioncode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePromotion(deletepromotion)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.promotionimage="{ item }">
                    <v-img
                    v-if="item.promotionimage" 
                    v-bind:src="item.promotionimage"
                    contain
                    width="100"
                  ></v-img>
              </template>
              <template v-slot:item.promotionstatus="{ item }">
                <v-chip
                  :color="!item.promotionstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.promotionstatus }}
                </v-chip>
              </template>
              <template v-slot:item.promotiondate="{ item }">
                {{ new Date(item.promotiondate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.promotionstartdate="{ item }">
                <p class="two-line">Start: {{ new Date(item.promotionstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                <p class="two-line">End: {{ new Date(item.promotionenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editPromotion(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PromotionList',
  data() {
    return {
      dialog: false,
      deletepromotion: {},
      headers: [
        { text: 'Image', value: 'promotionimage'},
        { text: 'Name', value: 'promotionname'},
        { text: 'Type', value: 'promotiontype'},
        { text: 'Date', value: 'promotiondate' },
        { text: 'Period', value: 'promotionstartdate' },
        { text: 'Status', value: 'promotionstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      promotionPerPage: 100,
      selected: [],      
    }
  },
  computed: {
    ...mapState('Promotion', ['promotions', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Promotion' : 'Edit Promotion'
    },
  },
  created () {
    this.getPromotionsRequest()
  },

  methods: {
    ...mapActions('Promotion', [
      "createPromotionRequest",
      "deletePromotionRequest",
      "getPromotionsRequest",
      "updatePromotionRequest",
    ]),
    editPromotion(item) {
      this.$router.push({ name: 'PromotionEdit', params: item })
    },
    deletePromotion(item) {
      this.deletePromotionRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepromotion = {
        _id: item._id,
        promotioncode: item.promotioncode,
      }
    },

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
